type GetPanelScaleParams = {
  containerWidth: number;
  containerHeight: number;
  logicalWidth: number;
  logicalHeight: number;
};

type PanelScaleResult = {
  panelScale: number;
  halfWidth: number;
};

/**
 * Calculates the scale factor and half-width needed to fit one panel of a
 * split inside face into the available container.
 */
export const getPanelScale = ({
  containerWidth,
  containerHeight,
  logicalWidth,
  logicalHeight,
}: GetPanelScaleParams): PanelScaleResult => {
  const halfWidth = logicalWidth / 2;
  const panelScale = Math.min(containerWidth / halfWidth, containerHeight / logicalHeight);
  return { panelScale, halfWidth };
};
